import { render, staticRenderFns } from "./LeadsBySource.vue?vue&type=template&id=bcf9f784&scoped=true&"
import script from "./LeadsBySource.vue?vue&type=script&lang=js&"
export * from "./LeadsBySource.vue?vue&type=script&lang=js&"
import style0 from "./LeadsBySource.vue?vue&type=style&index=0&id=bcf9f784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf9f784",
  null
  
)

export default component.exports